import { render, staticRenderFns } from "./FpuiInputTag.vue?vue&type=template&id=5d1e4f37&lang=pug&"
import script from "./FpuiInputTag.vue?vue&type=script&lang=js&"
export * from "./FpuiInputTag.vue?vue&type=script&lang=js&"
import style0 from "./FpuiInputTag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports